export default "__VITE_ASSET__oSpqPhTs__"